# Generated by https://pagedraw.io/pages/4922
React = require 'react'
_l = require 'lodash'

render = ->
    React.createElement("div", {"className": "fontimporter"},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            .fontimporter {
                display: flex;
                flex-grow: 1;
            }
            
            .fontimporter-initial-0 {
                display: flex;
                flex-direction: column;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .fontimporter-0-0-0 {
                display: flex;
            }
            
            .fontimporter-rectangle-7 {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                flex-basis: 0px;
                min-height: fit-content;
                padding-top: 27px;
                padding-bottom: 22px;
                border-radius: 7px;
                background: rgb(245, 245, 245);
                border: 3px solid rgb(214, 214, 214);
            }
            
            .fontimporter-0-0-0-0-0 {
                display: flex;
            }
            
            .fontimporter-0-0-0-0-0-0 {
                height: 0px;
                flex-grow: 0.5013927576601671;
                flex-basis: 0px;
            }
            
            .fontimporter-drop_your_font_file_here_-9 {
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: rgb(26, 23, 116);
                font-size: 18px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: bold;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                padding-right: 0.28125px;
            }
            
            .fontimporter-0-0-0-0-0-2 {
                height: 0px;
                flex-grow: 0.4986072423398329;
                flex-basis: 0px;
            }
            
            .fontimporter-0-0-0-0-1 {
                display: flex;
                margin-top: 16px;
            }
            
            .fontimporter-0-0-0-0-1-0 {
                height: 0px;
                flex-grow: 0.5013774104683195;
                flex-basis: 0px;
            }
            
            .fontimporter-or_click_to_select_a_file_to_upload_-5 {
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #000000;
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: center;
                word-wrap: break-word;
                padding-right: 0.125px;
            }
            
            .fontimporter-0-0-0-0-1-2 {
                height: 0px;
                flex-grow: 0.4986225895316804;
                flex-basis: 0px;
            }
            
            .fontimporter-0-0-0-0-2 {
                display: flex;
                margin-top: 26px;
                justify-content: center;
            }
            
            .fontimporter-text-6 {
                width: 460px;
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #000000;
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: center;
                word-wrap: break-word;
            }
            
            .fontimporter-importing-3 {
                display: flex;
                flex-direction: column;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .fontimporter-1-0-0 {
                display: flex;
                justify-content: center;
            }
            
            .fontimporter-image-8 {
                width: 104px;
                height: 104px;
                flex-shrink: 0;
                border-width: 0px;
            }
            
            .fontimporter-error-4 {
                display: flex;
                flex-direction: column;
                padding-top: 24px;
                padding-bottom: 34px;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .fontimporter-2-0-0 {
                display: flex;
                padding-left: 28px;
                padding-right: 28px;
            }
            
            .fontimporter-error_importing_file_-6 {
                width: 512px;
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: rgb(239, 80, 80);
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
            }
            
            .fontimporter-2-0-1 {
                display: flex;
                margin-top: 16px;
                padding-left: 28px;
                padding-right: 28px;
            }
            
            .fontimporter-please_contact_the_pagedraw_team_at_team_pagedraw_io_-0 {
                width: 512px;
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #000000;
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
            }
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        ( if ((if not _l.isEmpty(@props.error) then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Initial")
            React.createElement("div", {"className": "fontimporter-initial-0"},
                React.createElement("div", {"className": "fontimporter-0-0-0"},
                    React.createElement("div", {"className": "fontimporter-rectangle-7"},
                        React.createElement("div", {"className": "fontimporter-0-0-0-0-0"},
                            React.createElement("div", {"className": "fontimporter-0-0-0-0-0-0"}),  
                            React.createElement("div", {"className": "fontimporter-drop_your_font_file_here_-9"}, """
                                Drop your Font file here
"""),
                            React.createElement("div", {"className": "fontimporter-0-0-0-0-0-2"}) 
                        ),
                        React.createElement("div", {"className": "fontimporter-0-0-0-0-1"},
                            React.createElement("div", {"className": "fontimporter-0-0-0-0-1-0"}),  
                            React.createElement("div", {"className": "fontimporter-or_click_to_select_a_file_to_upload_-5"}, """
                                or click to select a file to upload
"""),
                            React.createElement("div", {"className": "fontimporter-0-0-0-0-1-2"}) 
                        ),
                        React.createElement("div", {"className": "fontimporter-0-0-0-0-2"},
                            React.createElement("div", {"className": "fontimporter-text-6"},
                                React.createElement("div", null, "Pagedraw uses file names to infer font names on upload."),
                                React.createElement("br", null),
                                React.createElement("div", null, "If trying to upload a missing font like Lato-regular"),
                                React.createElement("div", null, ("make sure your font file is named exactly \"Lato-regular.ttf\" or equivalent. "))
                            )
                        )
                    )
                )
            )
        ),
        ( if ((if not _l.isEmpty(@props.error) then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Importing")
            React.createElement("div", {"className": "fontimporter-importing-3"},
                React.createElement("div", {"className": "fontimporter-1-0-0"},
                    React.createElement("img", {"src": "https://complex-houses.surge.sh/59ec0968-b6e3-4a00-b082-932b7fcf41a5/loading.gif", "className": "fontimporter-image-8"}) 
                )
            )
        ),
        ( if ((if not _l.isEmpty(@props.error) then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Error")
            React.createElement("div", {"className": "fontimporter-error-4"},
                React.createElement("div", {"className": "fontimporter-2-0-0"},
                    React.createElement("div", {"className": "fontimporter-error_importing_file_-6"},
                        ( @props.error )
                    )
                ),
                React.createElement("div", {"className": "fontimporter-2-0-1"},
                    React.createElement("div", {"className": "fontimporter-please_contact_the_pagedraw_team_at_team_pagedraw_io_-0"}, """
                        Please contact the Pagedraw team at team@pagedraw.io
""")
                )
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/font-importer.cjsx